import React from 'react';
import { Reference } from '../../../types/content';
interface MarqueeRowProps {
  items: Reference[];
  reverse?: boolean;
}
export function MarqueeRow({
  items,
  reverse = false
}: MarqueeRowProps) {
  const loop = [...items, ...items];
  return <div className="group overflow-hidden" data-id="element-202" data-mp="39mb2r86likac">
      <ul className={`flex w-max group-hover:[animation-play-state:paused] ${reverse ? 'animate-marquee-reverse' : 'animate-marquee'}`} data-id="element-203" data-mp="3emyphhnskeyr">
        {loop.map((item, i) => <li key={`${item.name}-${i}`} aria-hidden={i >= items.length} className="flex items-center gap-5 px-6 py-6 md:px-10 md:py-8" data-id="element-204" data-mp="35n28m27n8ke9" data-mpi={i}>
            <span className="font-mono text-[11px] uppercase tracking-wider text-mute" data-id="element-205" data-mp="2vo2yef78cgp5">{item.kind}</span>
            <span className="whitespace-nowrap text-2xl font-medium tracking-[-0.03em] text-ink md:text-[42px]" data-id="element-206" data-mp="oxn39btxy756">
              {item.name}
            </span>
            <span className="ml-5 h-2.5 w-2.5 bg-ember md:ml-10" aria-hidden data-id="element-207" data-mp="tv5amxsb8eb2" />
          </li>)}
      </ul>
    </div>;
}